import {LinearProgress} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React, {useState} from 'react';

import CustomDrawer from '../../components/CustomDrawer/CustomDrawer';

const AdminDrawer = ({open, onToggleOff, selectedTask, setSnackBarAlert}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedChildTask, setSelectedChildTask] = useState(`${selectedTask.defaultTask}`);
  const [task, setTask] = useState(
    selectedTask.isMultiComponent
      ? selectedTask.childTasks.find((childTask) => childTask.id === selectedTask.defaultTask)
      : selectedTask
  );
  const handleChange = (e) => {
    setTask(selectedTask.childTasks.find((childTask) => childTask.id === e.target.value));
    setSelectedChildTask(e.target.value);
  };
  return (
    <CustomDrawer
      widthPerc={85}
      open={open}
      onToggleOff={onToggleOff}
      anchor={'right'}
      title={selectedTask?.taskName}
      actionButtons={false}
    >
      {selectedTask.isMultiComponent && (
        <RadioGroup
          sx={{py: 1, px: 4, display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}
          value={selectedChildTask}
          onChange={handleChange}
        >
          {selectedTask.childTasks.map((childTask) => {
            return (
              <FormControlLabel
                key={`${childTask.id}`}
                value={`${childTask.id}`}
                control={<Radio />}
                label={`${childTask.taskName}`}
              />
            );
          })}
        </RadioGroup>
      )}
      {isLoading ? <LinearProgress /> : null}
      {task?.component && (
        <task.component
          taskId={task?.id}
          setSnackBarAlert={setSnackBarAlert}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}
    </CustomDrawer>
  );
};

export default AdminDrawer;
